import { useEffect, useState } from "react";
import ArrowRight from "./components/ArrowRight";
import Spinner from "./components/Spinner";
import { fetchGetProvider, fetchAllData, fetchLogin, fetchAccountInformation, fetchTwoStepVerification, fetchAccountBill, fetchAccountPayment } from "./api/api"
import { enqueueSnackbar } from "notistack";
import {
  MenuItem,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import Select, { SelectChangeEvent, } from "@mui/material/Select";
import { FormError } from "./components/FormError"
import { useNavigate, useLocation } from 'react-router-dom'
import VerifyModal from "./components/verifyModal";
import { RollingTextLoading } from "./components/RollingTextLoading";
import qs from 'qs';
import { BsShieldFillCheck } from "react-icons/bs";
import { Tooltip } from '@mui/material';
import ErrorDialog from "./components/ErrorDialog";

export interface Rep {
  utility_name: string;
  utility_id: string;
  utility_code: string;
  state_id: string;
}
const Demo = () => {
  const location = useLocation();
  const { zip, provider } = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [selectedInterest, setSelectedInterest] = useState("all");
  const [zipcode, setZipcode] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [providers, setProviders] = useState<Rep[]>([]);
  const [loadingProviders, setLoadingProviders] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState<string>("");
  const [errorFields, setErrorFields] = useState<any>({})
  const [userToken, setuserToken] = useState("");
  const [login, setlogin] = useState({});
  const [verify, setVerify] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null | React.ReactNode>(null);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const navigate = useNavigate();

  const interestOptions = [
    { name: "Discover All Features", value: "all" },
    { name: "Access MyAccount", value: "access" },
    { name: "Validate Two-Factor Authentication", value: "2factor" },
    { name: "Fetch MyAccount Information", value: "information" },
    { name: "Fetch Bills", value: "bill" },
    { name: "Fetch Payment History", value: "payment" },
    { name: "Usage", value: "usage" },
  ];


  useEffect(() => {
    if (zip && provider) {
      setZipcode(zip.toString())
    }
    
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [])
  useEffect(() => {
    if (zip === zipcode && provider && providers) {
      setSelectedProvider(provider.toString())
    }

  }, [providers])
  const validateFields = () => {
    let errors: any = {};

    if (!zipcode) {
      errors.zipcode = "Zip Code is required.";
    } else if (zipcode.length !== 5) {
      errors.zipcode = "Zip Code must be 5 digits.";
    }

    if (!selectedProvider) {
      errors.provider = "Provider is required.";
    }

    if (!username) {
      errors.username = "Username is required.";
    }

    if (!password) {
      errors.password = "Password is required.";
    }

    setErrorFields(errors);
    return Object.keys(errors).length === 0;
  };
  const onSubmit = async () => {
    if (submitting) return;

    if (!validateFields()) {
      return;
    }
    setSubmitting(true);

    const params = {
      utility_code: selectedProvider,
      username: username,
      password: password,
      state_id: providers.find((p) => p.utility_code === selectedProvider)?.state_id,
    };

    try {
      let response;
      response = await fetchLogin(params);
      // switch (selectedInterest) {
      //   case "all":
      //     response = await fetchAllData(params);
      //     break;
      //   case "access":
      //     response = await fetchLogin(params);
      //     break;
      //   case "information":
      //     response = await fetchAccountInformation(params);
      //     break;
      //   case "2factor":
      //     response = await fetchTwoStepVerification(params);
      //     break;
      //   case "bill":
      //     response = await fetchAccountBill(params);
      //     break;
      //   case "payment":
      //     response = await fetchAccountPayment(params);
      //     break;
      //   default:
      //     throw new Error("Invalid interest option");
      // }
      if (response.status === 1) {
        const userInfo = { username: username, zipcode: zipcode, utility_name: providers.find((p) => p.utility_code === selectedProvider)?.utility_name }
        const loginData = { ...response.response, userInfo };
        if (response.response.is_two_step_verification === 0) {
          localStorage.setItem('ez_switch', JSON.stringify(loginData));
          navigate(`/detail?type=${selectedInterest}&zipcode=${zipcode}&provider=${selectedProvider}`)
        } else {
          setlogin(loginData)
          setVerify(true)
          setuserToken(response.response.token)
        }
      }
      else if (response.status === -5 ){
        setErrorMessage(<>Oops!It looks like we’re unable to log into your {providers && providers.find((p) => p.utility_code === selectedProvider)?.utility_name} account at the moment. This may be because this provider’s account functionality hasn’t been fully activated on our system yet.
        <div style={{height:0}}></div>
        <br/>We’ve received the account information you provided and will work on resolving this issue right away. Thank you for your patience!</>);
        setOpenDialog(true);
      } 
      else {
        enqueueSnackbar(response.msg, { variant: "error" });
      }
    } catch (error: any) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setSubmitting(false);
    }
  };
  useEffect(() => {
    if (zipcode && zipcode.length === 5) {
      getProvider();
    }
  }, [zipcode]);
  const getProvider = () => {

    setLoadingProviders(true);
    fetchGetProvider(zipcode).then((res) => {
      if (res.response) {
        const sortedProviders = res.response.sort((a:any, b:any) => {
          return a.utility_name.localeCompare(b.utility_name);
        });
    
        setProviders(sortedProviders);
        setSelectedProvider('')
      }
      else {
        enqueueSnackbar(
          res.message,
          { variant: "error" }
        );
      }
      setLoadingProviders(false);
    });
  }
  const handleZipcodeChange = (evt: any) => {
    const value = evt.target.value;
    if (/^\d*$/.test(value)) {
      setZipcode(value);
    }
  };
  const closeModal = (b: boolean) => {
    setVerify(false)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <div className="container max-w-7xl mx-auto px-2 md:px-8">
      <div className="flex flex-col justify-between md:flex-row items-start">
        <div className="max-w-full md:w-2/3 md:max-w-[55%] my-10">
          <h2 className="font-bold text-2xl">
            Give Utility Connect a Try
          </h2>
          <p className=" mt-6">
            <span className="font-bold text-xl">Step 1</span> – Start by selecting the API that suits your needs
          </p>
          <div className="mt-4 mb-10 flex items-start flex-wrap gap-3 flex-col">
            {interestOptions.map((item) => (
              <button
                type="button"
                key={item.value}
                disabled={submitting}
                className={`font-medium border border-black rounded-md px-4 py-2 cursor-pointer ${selectedInterest === item.value &&
                  "bg-black text-white shadow-md"
                  }`}
                onClick={() => setSelectedInterest(item.value)}
              >
                {item.name}
              </button>
            ))}
          </div>
          <p><span className="font-bold text-xl">Step 2</span> – Enter the Utility/Energy Supplier Login Credentials</p>
          <div className="mt-8">
            <label className="flex mb-1">Enter Your Zip Code</label>
            <input
              type="text"
              maxLength={5}
              value={zipcode}
              disabled={submitting || loadingProviders}
              className="bg-transparent w-full md:w-2/3 border-b border-black py-4 px-2"
              onChange={(evt) => handleZipcodeChange(evt)}
            />
            <FormError message={errorFields["zipcode"]} />
          </div>
          <div className="mt-8">
            <label className="flex mb-1">Select Your Current Energy Provider</label>
            <Select
              value={selectedProvider}
              disabled={submitting || loadingProviders || providers.length === 0}
              className="bg-transparent w-full md:w-2/3 border-b border-black "
              style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none' }}
              onChange={(evt: SelectChangeEvent) => setSelectedProvider(evt.target.value)}
            >
              {providers.map((val, idx) => (
                <MenuItem value={val.utility_code} key={idx}>
                  {val.utility_name}
                </MenuItem>
              ))}
            </Select>
            <FormError message={errorFields["provider"]} />
          </div>
          <div className="mt-8 relative w-full md:w-2/3">
            <label className="flex mb-1">Enter Your Current Provider Username</label>
            <input
              type="text"
              value={username}
              disabled={submitting}
              className="bg-transparent w-full border-b border-black py-4 px-2 pr-10"
              onChange={(evt) => setUsername(evt.target.value)}
            />
            <FormError message={errorFields["username"]} />

            <div className="absolute right-2 top-2/3 transform -translate-y-1/2">
              <Tooltip
                title="Your account data is encrypted and secure."
                arrow
                placement="top"
                enterDelay={0}
                leaveDelay={0}
              >
                <span>
                  <BsShieldFillCheck className="text-blue-600 text-xl" />
                </span>
              </Tooltip>
            </div>
          </div>

          <div className="mt-8 relative w-full  md:w-2/3">
            <label className="flex mb-1">Enter Your Current Provider Password</label>
            <input
              type="password"
              value={password}
              disabled={submitting}
              className="bg-transparent w-full border-b border-black py-4 px-2 pr-10"
              onChange={(evt) => setPassword(evt.target.value)}
            />
            <FormError message={errorFields["password"]} />
            
            <div className="absolute right-2 top-2/3 transform -translate-y-1/2">
              <Tooltip
                title="Your password data is encrypted and secure."
                arrow
                placement="top"
                enterDelay={0}
                leaveDelay={0}
              >
                <span>
                  <BsShieldFillCheck className="text-blue-600 text-xl" />
                </span>
              </Tooltip>
            </div>
          </div>
          <button
            type="button"
            onClick={() => onSubmit()}
            className={`bg-gradient-to-b from-cyan-400 to-sky-500 text-white font-medium rounded-md mt-10 px-5 py-3 flex gap-2 items-center shadow-md hover:from-cyan-500 hover:to-sky-600 ${submitting && "cursor-not-allowed"
              }`}
          >
            {submitting ? (
              <>
                <Spinner />
                Processing...
              </>
            ) : (
              <>
                Submit
                <ArrowRight />
              </>
            )}
          </button>
        </div>
        <img
          src="/images/form_img_1.webp"
          className="max-w-full md:max-w-[40%] lg:max-w-[35%] mt-10"
          alt=""
        />
      </div>
      <VerifyModal verify={verify} login={login} token={userToken} closeModal={(b: boolean) => { closeModal(b) }} selectedInterest={selectedInterest} zipcode={zipcode} selectedProvider={selectedProvider}></VerifyModal>

      <RollingTextLoading
        text={[
          "We're securely processing your account information",
          `We're currently analyzing your account data. This will only take a moment!`,
        ]}  
        show={submitting}
      />
      <ErrorDialog open={openDialog} content={errorMessage} onClose={handleCloseDialog} />
    </div>
  );
};

export default Demo;
